import { render, staticRenderFns } from "./OrgLeadsStatsByDay.vue?vue&type=template&id=bcc2db82&scoped=true&"
import script from "./OrgLeadsStatsByDay.vue?vue&type=script&lang=js&"
export * from "./OrgLeadsStatsByDay.vue?vue&type=script&lang=js&"
import style0 from "./OrgLeadsStatsByDay.vue?vue&type=style&index=0&id=bcc2db82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc2db82",
  null
  
)

export default component.exports